<script>
    export let fill = '#FFF'
</script>

<style>
    svg {
        position: absolute;
        top: 47px;
        left: 0.5px;
    }
</style>

<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 413 45">
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <rect {fill} width="413" height="45" />
        </g>
    </g>
</svg>
